'use client';

import { PersonalUserGeneralForm } from '@bb/components/PersonalUserForms/PersonalUserGeneralForm';
import type { OnboardingStep } from './types';

export function FirstLastNameStep(props: {
  setCurrentStep: (step: OnboardingStep) => void;
  onStepSuccess: () => Promise<void>;
}) {
  return (
    <PersonalUserGeneralForm
      onSuccess={props.onStepSuccess}
      submitButtonLabel="Continue"
    />
  );
}
